import { axiosApiService } from './axios';

const DevIndexAPIs = {
  get_dev_index: async function () {
    try {
      const response = await axiosApiService.get(`/dev_index/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching dev index data', error);
      throw error;
    }
  },

  update_dev_index: async function (id, values) {
    try {
      const response = await axiosApiService.patch(
        `/dev_index/${id}/update_dev_index/`,
        values
      );
      return response;
    } catch (error) {
      console.error('Error updating dev index data', error);
      throw error;
    }
  },

  add_dev_index: async function (id, values) {
    try {
      const response = await axiosApiService.post(
        `/dev_index/${id}/add_dev_index/`,
        values
      );
      return response;
    } catch (error) {
      console.error('Error adding dev index data', error);
      throw error;
    }
  },
};

export default DevIndexAPIs;
